/*
 * @Description: 主题稿库路由
 * @Author: pu.yuchun
 * @LastEditors: zhaoqing
 * @Date: 2019-12-03 16:48:33
 * @LastEditTime: 2020-05-08 15:50:34
 */
'use strict';
angular.module('resCenterZTRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.resourcectrl.theme.resource', {
            url: '/resource?type&theme&change',
            views: {
                'resource@front.resourcectrl.theme': {
                    templateUrl: './resourceCenter/theme/theme_tpl.html',
                    controller: 'resourceCenterThemeCtrl'
                }
            }
        }).state('front.resourcectrl.theme.quickpreview', {
            url: '/quickpreview?type&theme&change&guid',
            views: {
                'resource@front.resourcectrl.theme': {
                    templateUrl: './resourceCenter/theme/quickPreview/main_tpl.html',
                    controller: 'themeQuickPreviewCtrl'
                }
            }
        });
    }
]);
